import { API } from 'utils/globalApiServices';
export const getListUsersService = async () => {
  const url = 'roleplays/list/users/';
  const { data } = await API.get(url);
  return data?.list || [];
};

export const createModuleAssessment = async ({ module_uuid = '', questions = {} }) => {
  const url = `module/${module_uuid}/assessments/create/`;
  const data = await API.post(url, { ...questions });
  return data;
};

export const getModuleAssessmentQuestions = async (module_uuid = '') => {
  const url = `module/${module_uuid}/assessments/questions/`;
  const data = await API.get(url);
  return data;
};

export const putModuleAssessmentQuestions = async ({ module_uuid = '', questions = {} }) => {
  const url = `module/${module_uuid}/assessments/update/`;
  const data = await API.put(url, { ...questions });
  return data;
};

export const getAIStatusPerModule = async (module_uuid = '') => {
  const url = `module/${module_uuid}/ai-usage-status/`;
  const data = await API.get(url);
  return data;
};

export const getSkillPathYourProgress = async () => {
  const url = `learning-paths/your-progress/`;
  const data = await API.get(url);
  return data;
};

export const getSkillPathsResume = async () => {
  const url = `learning-path/resume/`;
  const data = await API.get(url);
  return data;
};

export const getSkillPathsHistory = async ({ page = 1 }) => {
  const url = `learning-path/skill-path-history/?page=${page}`;
  const data = await API.get(url);
  return data;
};

export const getSkillPathsTotal = async () => {
  const url = `learning-path/total/`;
  const data = await API.get(url);
  return data;
};

export const getUserTypeDetails = async () => {
  const url = `learning-path/user-type/`;
  const data = await API.get(url);
  return data;
};

export const getSkillPathTotalUsersProgress = async () => {
  const url = `learning-paths/users-progress/`;
  const data = await API.get(url);
  return data;
};

export const getSkillPathDetails = async ({ page = 1 }) => {
  const url = `learning-path/admin-details/?page=${page}`;
  const data = await API.get(url);
  return data;
};

export const getHomeSkillPaths = async () => {
  const url = `home/learning-paths/`;
  const data = await API.get(url);
  return data;
};